import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhyResistance from './components/WhyResistance';
import ChangeByOrder from './components/ChangeByOrder';
import ChangeTypes from './components/ChangeTypes';
import ManagerRole from './components/ManagerRole';
import ManagerMistakes from './components/ManagerMistakes';
import WorkingWithResistance from './components/WorkingWithResistance';
import CommunicationSection from './components/CommunicationSection';
import ChangeSkills from './components/ChangeSkills';
import PracticalSituations from './components/PracticalSituations';
import HowPracticeGoes from './components/HowPracticeGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import FormatsSection from './components/FormatsSection';
import HowProgramGoes from './components/HowProgramGoes';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function ChangeManagementPage() {
  return (
    <>
      
      <SeoTitle title="Управление изменениями | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhyResistance />
        <ChangeByOrder />
        <ChangeTypes />
        <ManagerRole />
        <ManagerMistakes />
        <WorkingWithResistance />
        <CommunicationSection />

        <div id="skills">
          <ChangeSkills />
        </div>

        <PracticalSituations />
        <HowPracticeGoes />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <FormatsSection />

        <div id="process">
          <HowProgramGoes />
        </div>

        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}